<template>
    <div>
        <b-card
            tag="article"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="6" md="4" lg="4">
                        <b>Cliente:</b>
                        <div>{{vehicleEntry.client.name}}</div>
                        <hr> 
                    </b-col>
                    <b-col cols="6" md="4" lg="4">
                        <b>Sede:</b>
                        <div>{{vehicleEntry.venue.name}}</div>
                        <hr>
                    </b-col>
                    <b-col cols="6" md="4" lg="4">
                        <b>Estructura:</b>
                        <div>{{vehicleEntry.structure.name}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="6" md="4" lg="4">
                        <b>Placa:</b>
                        <div> {{vehicleEntry.plate}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="6" md="4" lg="4">
                        <b>Material:</b>
                        <div> {{vehicleEntry.material}}</div>
                        <hr> 
                    </b-col>
                    <b-col cols="6" md="4" lg="4">
                        <b>Proveedor:</b>
                        <div> {{vehicleEntry.cargo_vendor.name}}</div> 
                        <hr>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" lg="6">
                        <b-card
                            tag="article"
                            class="mb-2"
                            title="Ingreso"

                        >
                        <div class="card-text">
                            <b-col cols="12">
                                <b>Fecha entrada:</b>
                                <div>{{vehicleEntry.entry_date | date}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Hora entrada:</b>
                                <div>{{vehicleEntry.check_in}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Registrado por:</b> 
                                <div>{{vehicleEntry.entry_registered_by.name}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Conductor:</b>
                                <div>{{vehicleEntry.entry_cargo_driver.name}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Entregado por:</b>
                                <div>{{vehicleEntry.delivered_by}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Peso de entrada:</b>
                                <div v-if="vehicleEntry.initial_weight">{{vehicleEntry.initial_weight}}</div>
                                <div v-else> No se registro peso de ingreso. </div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Notas de ingreso:</b>
                                <div v-if="vehicleEntry.entry_notes">{{vehicleEntry.entry_notes}}</div>
                                <div v-else> No se agregaron notas de ingreso.</div> 
                                <hr>
                            </b-col>
                        </div>
                        </b-card>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-card
                            title="Salida"
                            tag="article"
                            class="mb-2"
                        >
                        <div class="card-text" v-if="!vehicleEntry.departure_date"> 
                            <b-col cols="12">
                                No se ha registrado salida
                            </b-col> 
                        </div>
                        <div class="card-text" v-else>
                            <b-col cols="12">
                                <b>Fecha salida:</b>
                                <div>{{vehicleEntry.departure_date | date}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Hora salida:</b>
                                <div>{{vehicleEntry.check_out}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Registrado por:</b> 
                                <div>{{vehicleEntry.departure_registered_by.name}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Conductor:</b>
                                <div>{{vehicleEntry.departure_cargo_driver.name}}</div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Peso de salida:</b>
                                <div v-if="vehicleEntry.final_weight">{{vehicleEntry.final_weight}}</div>
                                <div v-else> No se registro peso de salida. </div>
                                <hr> 
                            </b-col>
                            <b-col cols="12">
                                <b>Notas de salida:</b>
                                <div v-if="vehicleEntry.departure_notes">{{vehicleEntry.departure_notes}}</div>
                                <div v-else> No se agregaron notas de salida.</div> 
                                <hr> 
                            </b-col>
                        </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        vehicleEntry: {
            required: true
        }
    }
}
</script>